module.exports = __webpack_public_path__ + "static/diamond-4f410b28a19259433e5b057f5ab50dbd.svg";